import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Argon from "./plugins/argon-kit";
import http from "./services/http";
import axios from "axios";
import ElementUI from 'element-ui';
import store from "./store";
import VueI18n from "vue-i18n";
import localeI18n from "./i18n";
import I18nInput from "./components/shared/I18nInput";
import './assets/css/element-variables.scss';
import * as VueGoogleMaps from "vue2-google-maps";
import VueApexCharts from 'vue-apexcharts'
import VCalendar from 'v-calendar';
import VueHtmlToPaper from 'vue-html-to-paper';
import locale from 'element-ui/lib/locale/lang/uz-UZ'
import moment from "moment";
import SpeechSynthesis from 'speech-synthesis';

Vue.use(ElementUI, { locale })
Vue.prototype.moment = moment

Vue.config.productionTip = false;
Vue.component("i18n-input", I18nInput);
Vue.use(Argon);
Vue.use(VueI18n);
Vue.prototype.$locales = localeI18n.locales;
Vue.prototype.$http = http;
Vue.prototype.$axios = axios;
Vue.use(VueApexCharts);
Vue.use(VCalendar);
Vue.use(VueHtmlToPaper);
Vue.use(SpeechSynthesis);

Vue.component("apexchart", VueApexCharts);

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyA4VzwaNGjwWOEayyophRSGjbUel_IV5xg",
    libraries: "places" // necessary for places input
  }
});

Vue.use(ElementUI, {
    i18n: (key, value) => i18n.t(key, value)
});

const i18n = new VueI18n({
    locale: store.state.locale,
    messages: localeI18n.messages
});

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
